import React, { useState, useEffect } from "react";
import { ShoppingCart, Package, Music } from "lucide-react";
import Footer from "./components/Footer";
import { useFanClub } from "../contexts/AppContext";
import { formatHUF } from "../lib/format";
import { BACKEND_URL } from "../config";

export default function VasarlasaimPage() {
  const { getMyOrders } = useFanClub();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMyOrders()
      .then((data) => setOrders(data.orders || []))
      .finally(() => setLoading(false));
  }, [getMyOrders]);

  return (
    <div data-testid="vasarlasaim-page">
      <div className="min-h-screen pt-24 sm:pt-32 pb-32 px-4 sm:px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8 sm:mb-16 animate-fade-in">
            <p className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-primary mb-2 sm:mb-4">Fan Club</p>
            <h1 className="text-3xl sm:text-5xl font-bold font-['Syne'] tracking-tighter">Vásárlásaim</h1>
            <p className="text-muted-foreground text-sm mt-2">Fizikai és digitális vásárlásaid egy helyen.</p>
          </div>
          {loading ? (
            <div className="glass rounded-xl p-8 text-center text-muted-foreground animate-fade-in">Betöltés...</div>
          ) : orders.length === 0 ? (
            <div className="glass rounded-xl p-8 text-center text-muted-foreground animate-fade-in">
              <ShoppingCart className="h-12 w-12 mx-auto mb-4 opacity-50" />
              <p>Még nincs megrendelésed.</p>
            </div>
          ) : (
            <div className="space-y-6 animate-fade-in">
              {orders.map((order) => (
                <div key={order.id} className="glass rounded-xl p-4 sm:p-6">
                  <div className="flex flex-wrap items-center justify-between gap-2 mb-4 pb-3 border-b border-white/10">
                    <span className="text-xs text-muted-foreground">
                      {new Date(order.created_at).toLocaleDateString('hu-HU', { dateStyle: 'long' })}
                    </span>
                    <span className="font-bold text-primary">{formatHUF(order.total)}</span>
                  </div>
                  <ul className="space-y-3">
                    {order.items.map((item, idx) => (
                      <li key={idx} className="flex items-center gap-3">
                        {item.image ? (
                          <img src={`${BACKEND_URL}/storage/${item.image}`} alt="" className="w-12 h-12 rounded-lg object-cover bg-white/5" />
                        ) : item.item_type === 'album' ? (
                          <div className="w-12 h-12 rounded-lg bg-primary/20 flex items-center justify-center">
                            <Music className="h-6 w-6 text-primary" />
                          </div>
                        ) : (
                          <div className="w-12 h-12 rounded-lg bg-white/10 flex items-center justify-center">
                            <Package className="h-6 w-6 text-muted-foreground" />
                          </div>
                        )}
                        <div className="flex-1 min-w-0">
                          <p className="font-medium text-sm truncate">{item.product_name}</p>
                          <p className="text-xs text-muted-foreground">
                            {formatHUF(item.price)} × {item.quantity}
                            {item.size && ` · ${item.size}`}
                            {item.has_download && ' · Digitális letöltés'}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
